const dynamicPackage = {
  detailedPlan: "خطة مفصلة", // translated 
  minimum: "الحد الأدنى", // translated 
  maximum: "أقصى", // translated 
};



export default dynamicPackage;
